import template from './view.html'

export default function queryTree(logger, $timeout, httpRequest, $uibModal) {
    return {
        restrict: 'EA',
        scope: {
            treeData: '<',
            config: '<',
            model: '=',
        },
        template,
        link(scope) {
            if (scope.config && scope.config.width) {
                scope.widthStyle = {
                    width: scope.config.width,
                }
            } else {
                scope.widthStyle = ''
            }
            if (scope.config && scope.config.inputName) {
                scope.inputName = scope.config.inputName
            } else {
                scope.inputName = 'orgName'
            }
            scope.obj = {
                selectNodes: scope.model,
            }
            scope.$watch('treeData', function (newValue, oldValue) {
                if (newValue) {
                    scope.treeData = newValue
                }
            })
            scope.$watch('obj.selectNodes', function (n, o) {
                if (n) {
                    scope.model = n
                }
            })
            scope.open = function open() {
                scope.hasSearchFocus = true
                scope.hasSearchVal = true
            }
            scope.close = function open() {
                scope.hasSearchFocus = false
                scope.hasSearchVal = false
            }
        },
    }
}
queryTree.$inject = ['logger', '$timeout', 'httpRequest', '$uibModal']



// WEBPACK FOOTER //
// ./src/components/queryTree/queryTree.js